export default __webpack_public_path__ + "static/media/woman-with-phone.95fff68a.png";